"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.grammarErrorSchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.grammarErrorSchema = zod_1.default.enum([
    "adjective",
    "adjective_form",
    "adverb",
    "conjunction",
    "contraction",
    "determiner",
    "morphology",
    "noun",
    "noun_inflection",
    "noun_number",
    "noun_possessive",
    "orthography",
    "other",
    "particle",
    "preposition",
    "pronoun",
    "punctuation",
    "spelling",
    "unknown",
    "verb",
    "verb_form",
    "verb_inflection",
    "subject_verb_agreement",
    "verb_tense",
    "word_order",
]);
//# sourceMappingURL=grammar.js.map